import { AceClaimAction, AceClaimActionTypes, AceClaimState } from "./types";

const initialState: AceClaimState = {
  claimId: "",
  statusCode: "",
  plan: {},
  data: {},
  customerId: "",
  customer_data: {},
  warranty_items: [],
  claim_items: [],
  status: "",
};

export const aceClaimReducer = (
  state: AceClaimState = initialState,
  action: AceClaimActionTypes
): AceClaimState => {
  switch (action.type) {
    case AceClaimAction.SET_WARRNTY_ITEMS: {
      return {
        ...state,
        warranty_items: action?.payload || [],
      };
    }

    case AceClaimAction.SET_CLAIM_INFO: {
      return {
        ...state,
        claimId: action?.payload?.claimId || state?.claimId || "",
        status: action?.payload?.status || state?.status || "",
        plan: action?.payload?.plan || state?.plan || {},
        warranty_items:
          action?.payload?.warranty_items || state?.warranty_items || [],
        claim_items: action?.payload?.claim_items || state?.claim_items || [],
        data: action?.payload?.data || state?.data || {},
        customerId: action?.payload?.customerId || state?.customerId || {},
        customer_data:
          action?.payload?.customer_data || state?.customer_data || {},
      };
    }

    case AceClaimAction.CLEAN_UP: {
      return {
        ...state,
        claimId: "",
        plan: {},
        data: {},
        warranty_items: [],
        claim_items: [],
        statusCode: "",
        customer_data: {},
        customerId: "",
      };
    }

    default:
      return state;
  }
};
